<template>
  <div class="">
    <landing-navigation />

    <section class="text-white" style="background:rgba(25, 0, 135, 0.9);;">
      <div class="container mx-auto text-center py-10 px-6 " style=" height: 80vh;display: flex; align-items: center;">
          <div>
            <h1 class="pp-dual-heading">
									<span class="pp-first-text">
						      <span class="heading-gred">Powerful API Stack</span></span>
										<span class="pp-second-text">For Data-Driven Marketers</span>
								</h1>
                <p class="header_p mt-4" >We provide comprehensive SEO and digital marketing data solutions via API. Everything your SEO software requires — in one place.</p>
          </div>
      </div>
    </section>



    <!-- API GRID SECTION START -->

    <section class="apigridsection bg-gray-100 pt-24 pb-6">
        <div class="container mx-auto px-6">
          <h2 class="text-center">Some Of Our APIs</h2>
          <div class="apiGridRow pt-24">
            <div class="w-full mb-5 lg:px-10 apiGrid">
              <div>
                <span class="gridimage">
                  <img src="@/assets/images/features/Search-Engine.webp" alt="" style="max-width: 30px;">
                </span>
              </div>
              <div class="gridapicontent mt-4">
                <h4 class="pt-3">SERP API</h4>
                <p class="pt-5">Your one-stop datasource of structured SERP data</p>
                <a href="#">LEARN MORE</a>
              </div>
            </div>
            <div class="w-full mb-5 lg:px-10 apiGrid">
              <div>
                <span class="gridimage">
                  <img src="@/assets/images/features/Google-adwords.webp" alt="" style="max-width: 30px;">
                </span>
              </div>
              <div class="gridapicontent mt-4">
                <h4 class="pt-3">Google Ads API</h4>
                <p class="pt-5">Your one-stop datasource of structured SERP data</p>
                <a href="#">LEARN MORE</a>
              </div>
            </div>
            <div class="w-full mb-5 lg:px-10 apiGrid">
              <div>
                <span class="gridimage">
                  <img src="@/assets/images/features/Seo-Analysis.webp" alt="" style="max-width: 30px;">
                </span>
              </div>
              <div class="gridapicontent mt-4">
                <h4 class="pt-3">Google Trends API</h4>
                <p class="pt-5">Your one-stop datasource of structured SERP data</p>
                <a href="#">LEARN MORE</a>
              </div>
            </div>
            <div class="w-full mb-5 lg:px-10 apiGrid">
              <div>
                <span class="gridimage">
                  <img src="@/assets/images/features/Domain.webp" alt="" style="max-width: 30px;">
                </span>
              </div>
              <div class="gridapicontent mt-4">
                <h4 class="pt-3">Domain Analytics API</h4>
                <p class="pt-5">Your one-stop datasource of structured SERP data</p>
                <a href="#">LEARN MORE</a>
              </div>
            </div>
          </div>
          <div class="apiGridRow pt-10">
            <div class="w-full mb-5 lg:px-10 apiGrid">
              <div>
                <span class="gridimage">
                  <img src="@/assets/images/features/Group.webp" alt="" style="max-width: 30px;">
                </span>
              </div>
              <div class="gridapicontent mt-4">
                <h4 class="pt-3">On-page aPI</h4>
                <p class="pt-5">Your one-stop datasource of structured SERP data</p>
                <a href="#">LEARN MORE</a>
              </div>
            </div>
            <div class="w-full mb-5 lg:px-10 apiGrid">
              <div>
                <span class="gridimage">
                  <img src="@/assets/images/features/Seo-File.webp" alt="" style="max-width: 30px;">
                </span>
              </div>
              <div class="gridapicontent mt-4">
                <h4 class="pt-3">DataForSEO</h4>
                <p class="pt-5">Your one-stop datasource of structured SERP data</p>
                <a href="#">LEARN MORE</a>
              </div>
            </div>
            <div class="w-full mb-5 lg:px-10 apiGrid">
              <div>
                <span class="gridimage">
                  <img src="@/assets/images/features/download.webp" alt="" style="max-width: 30px;">
                </span>
              </div>
              <div class="gridapicontent mt-4">
                <h4 class="pt-3">Backlinks API</h4>
                <p class="pt-5">Your one-stop datasource of structured SERP data</p>
                <a href="#">LEARN MORE</a>
              </div>
            </div>
            <div class="w-full mb-5 lg:px-10 apiGrid">
              <div>
                <span class="gridimage">
                  <img src="@/assets/images/features/storefront_FILL1_wght400_GRAD0_opsz48-1.webp" alt="" style="max-width: 30px;">
                </span>
              </div>
              <div class="gridapicontent mt-4">
                <h4 class="pt-3">Merchant API</h4>
                <p class="pt-5">Your one-stop datasource of structured SERP data</p>
                <a href="#">LEARN MORE</a>
              </div>
            </div>
          </div>
        </div>
      </section>




    <!-- API GRID SECTION END -->





    <section class="bg-gray-100 pt-24 pb-6">
      <div class="container mx-auto px-6">

        <!-- feature import -->
        <!-- <div class="flex flex-row flex-wrap items-center">

            <div class="w-full lg:w-1/2 lg:px-10 mb-24">
              <img src="@/assets/images/features/feature-import-2.jpg" class="shadow-md rounded-lg w-full" alt="" style="">
            </div>

            <div class="w-full lg:w-1/2 lg:px-10 mb-24">
              <h2 class="text-xl font-bold mb-4 text-gray-800">We make it easy to import your contacts</h2>
              <div class="text-gray-800 mb-10">Import your existing contacts directly from your accounting software or payment processor. You can upload a CSV File with your contacts as well. We take care of filtering and removing any duplicate contacts for you.</div>

              <div class="flex flex-row">
                <div class="mr-4">
                  <img src="@/assets/images/features/pic-jou-wong.jpg" class="rounded-full border-2 border-white" style="width: 70px;" alt="">
                </div>
                <div class="flex-1">
                  <div class="italic text-sm text-gray-600 mb-2">"Finally, we got rid of our spreadsheets and started to manage our invites with one tool. Their <span class="font-bold">Stripe integration</span> makes it easy to keep our contacts information up to date."</div>
                  <div class="text-sm">- Jou Wong</div>
                </div>
              </div>

            </div>

        </div> -->

        <!-- feature invite -->
        <div class="flex flex-row flex-wrap items-center featuresection">

            <div class="w-full lg:w-1/2 lg:px-10 mb-24">
              <h2 class="text-xl font-bold mb-4 text-gray-800">On demand access to Quality Data</h2>
              <ol class="custom-list mb-8 ">
                <li>Get access to structured data in real-time. No need to worry about blocking mechanisms and anti-bot tech.</li>
                <li>Our data APIs are ready to use, there is no need for configuring your parser for attributes and selectors.</li>
                <li>Simple pricing, pay per successful result only. Say goodbye to being charged for failed requests.</li>
              </ol>
              <span>
              <a href="#" class="btn getstartedbutton ">GET STARTED</a>
            </span>
            </div>

            <div class="w-full lg:w-1/2 lg:px-10 mb-24">
              <img src="@/assets/images/features/Group-30.webp" class="shadow-md rounded-lg w-full overflow-hidden" alt="" style="">
            </div>

        </div>

        <!-- feature user segmentation -->
        <div class="flex flex-row flex-wrap items-center featuresection">

            <div class="w-full lg:w-1/2 lg:px-10 mb-24 flex flex-row justify-end items-center">
              <img src="@/assets/images/features/Group-30-1-1.webp" class="shadow-md rounded-lg w-full overflow-hidden" alt="">
            </div>

            <div class="w-full lg:w-1/2 lg:px-10 mb-24">
              <h2 class="text-xl font-bold mb-4 text-gray-800">Standard JSON format for all platforms</h2>
              <ol class="custom-list mb-8 ">
                <li>Get details like product name, url, thumbnail, pricing, model number, stock status and more with our search API</li>
                <li>Extract more information using product urls with our product detail and reviews APIs</li>
                <li>Special attributes like search suggestions, sales numbers, bestseller ranks and more available on certain platforms</li>
              </ol>
   
              <span>
              <a href="#" class="btn getstartedbutton ">GET STARTED</a>
            </span>
            </div>
        

        </div>




      </div>
    </section>




    <!-- faq section start -->

    <section class="bg-gray-100  pb-6 faqsection">
      <div class="container mx-auto px-6">
        <h2 class="text-center">Frequently Asked Question</h2>

        <div class="mt-8">
          <div >
            <div class="faqsectionques" v-for="(faq, index) in faqs" :key="index">
              <h2 @click="activeFaqIndex = activeFaqIndex === index ? null : index">
                <i :class="activeFaqIndex === index ? 'fa fa-minus-circle' : 'fa fa-plus-circle'"></i> {{ faq.question }}
              </h2>
              <div class="mt-4" v-if="activeFaqIndex === index">
                {{ faq.answer }}
              </div>
            </div>
          </div>
      </div>
    </div>
    </section>


    <!-- faq section end -->

    <!-- Pricing -->
    <!-- <section id="pricing" class="mt-20 mb-12">
      <div class="container mx-auto px-6">

        <div class="flex flex-row flex-wrap justify-center">
          
          <div class="flex flex-col px-12 mb-8 justify-between">
            <h3 class="text-2xl font-semibold text-center mb-2">Free</h3>

            <div class="mb-6">
              <div class="whitespace-no-wrap text-center"><span class="text-3xl font-bold mr-1">$0</span>/month</div>
            </div>

            <div class="flex flex-col">
              <div class="mb-6">

                <div class="mb-2 border-b border-dotted">
                  <div class="text-sm mb-1">10 Email Invites</div>
                </div>

                <div class="mb-2 border-b border-dotted">
                  <div class="text-sm mb-1">0 SMS Invites</div>
                </div>

                <div class="mb-2 border-b border-dotted">
                  <div class="text-sm mb-1"><span class="font-bold">Unlimited</span> Review Platforms</div>
                </div>

                <div class="mb-2 border-b border-dotted">
                  <div class="text-sm mb-1"><span class="font-bold">Unlimited</span> Connected Apps</div>
                </div>


              </div>

              <router-link to="/signup">
                <button class="w-full bg-green-500 rounded text-white px-3 py-2 hover:bg-green-400">Get Started Free</button>
              </router-link>
              
            </div>
            
          </div>

          <div class="flex flex-col px-12 mb-8 justify-between">
            <h3 class="text-2xl font-semibold text-center mb-2">Starter</h3>

            <div class="mb-6">
              <div class="whitespace-no-wrap text-center"><span class="text-3xl font-bold mr-1">$5</span>/month</div>
            </div>

            <div class="flex flex-col">
              <div class="mb-6">

                <div class="mb-2 border-b border-dotted">
                  <div class="text-sm mb-1">100 Email Invites</div>
                </div>

                <div class="mb-2 border-b border-dotted">
                  <div class="text-sm mb-1">10 SMS Invites</div>
                </div>

                <div class="mb-2 border-b border-dotted">
                  <div class="text-sm mb-1"><span class="font-bold">Unlimited</span> Review Platforms</div>
                </div>

                <div class="mb-2 border-b border-dotted">
                  <div class="text-sm mb-1"><span class="font-bold">Unlimited</span> Connected Apps</div>
                </div>


              </div>

              <router-link to="/signup">
                <button class="w-full bg-green-500 rounded text-white px-3 py-2 hover:bg-green-400">Get Started Free</button>
              </router-link>
              
            </div>
            
          </div>

          <div class="flex flex-col px-12 mb-8 justify-between">
            <h3 class="text-2xl font-semibold text-center mb-2">Business</h3>

            <div class="mb-6">
              <div class="whitespace-no-wrap text-center"><span class="text-3xl font-bold mr-1">$29</span>/month</div>
            </div>


            <div class="flex flex-col">
              <div class="mb-6">

                <div class="mb-2 border-b border-dotted">
                  <div class="text-sm mb-1">1000 Email Invites</div>
                </div>

                <div class="mb-2 border-b border-dotted">
                  <div class="text-sm mb-1">100 SMS Invites</div>
                </div>

                <div class="mb-2 border-b border-dotted">
                  <div class="text-sm mb-1"><span class="font-bold">Unlimited</span> Review Platforms</div>
                </div>

                <div class="mb-2 border-b border-dotted">
                  <div class="text-sm mb-1"><span class="font-bold">Unlimited</span> Connected Apps</div>
                </div>


              </div>


              <router-link to="/signup">
                <button class="w-full bg-green-500 rounded text-white px-3 py-2 hover:bg-green-400">Get Started Free</button>
              </router-link>
            
            </div>
            
          </div>

          <div class="flex flex-col px-12 mb-8 justify-between">
            <h3 class="text-2xl font-semibold text-center mb-2">Enterprise</h3>

            <div class="mb-6">
              <div class="whitespace-no-wrap text-center">Contact sales</div>
            </div>


            <div class="flex flex-col">
              <div class="mb-6">

                <div class="mb-2 border-b border-dotted">
                  <div class="text-sm mb-1">> 1000 Email Invites</div>
                </div>

                <div class="mb-2 border-b border-dotted">
                  <div class="text-sm mb-1">> 100 SMS Invites</div>
                </div>

                <div class="mb-2 border-b border-dotted">
                  <div class="text-sm mb-1"><span class="font-bold">Unlimited</span> Review Platforms</div>
                </div>

                <div class="mb-2 border-b border-dotted">
                  <div class="text-sm mb-1"><span class="font-bold">Unlimited</span> Connected Apps</div>
                </div>

              </div>

              <router-link to="/contact">
                <button class="w-full bg-white rounded text-green-500 px-3 py-2 border border-green-500 hover:bg-gray-100">Contact sales</button>
              </router-link>

            </div>

            
          </div>

        </div>

      </div>
    </section> -->

    <!-- Integrates with -->
    <!-- <section class="bg-gray-200">
      <div class="container mx-auto px-6">

        <div class="flex flex-col items-center">
          
          <div class="text-gray-600 mt-12">Integrates with</div>

          <div class="flex flex-row flex-wrap items-center justify-center mt-8 mb-16">
            <img src="@/assets/images/providers/logos/logo-gray-stripe.png" class="mx-8" alt="" style="height:30px;">
            <img src="@/assets/images/providers/logos/logo-gray-sevdesk.png" class="mx-8" alt="" style="height:30px;">
            <img src="@/assets/images/providers/logos/logo-gray-quickbooks.png" class="mx-8" alt="" style="height:50px;">
            <img src="@/assets/images/providers/logos/logo-gray-xero.png" class="mx-8" alt="" style="height:50px;">
          </div>

        </div>

      </div>
    </section> -->

    <!-- Footer -->
    <landing-footer />


  </div>
</template>



<script>
import LandingNavigation from '@/components/LandingNavigation.vue'
import LandingFooter from '@/components/LandingFooter.vue'

export default {
  components: {
    LandingNavigation,
    LandingFooter
  },
  metaInfo: {
    title: 'Lead Finder: Automated review follow-ups for your business',
    meta: [
      { name: 'description', content: 'Collect more reviews with automated Email and SMS invites for your online or offline business. Build customer trust and increase search engine ranking.' },
      { name: 'keywords', content: 'review, generation, automation, feedback, customers, reviews, more customer reviews, reputation'}
    ]
  },
  created() {
    // if (window.location.origin != process.env.VUE_APP_MAIN_URL) {
      // this.$router.push('/dashboard')
    // }
  },
      data() {
      return {
        faqs: [
          { 
            question: 'Why should I scrape reviews?', 
            answer: 'Click edit button to change this text. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit tellus, luctus nec ullamcorper mattis, pulvinar dapibus leo.' 
          },
          { 
            question: 'How Do I sign Up?', 
            answer: 'Click edit button to change this text. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit tellus, luctus nec ullamcorper mattis, pulvinar dapibus leo.' 
          },
          { 
            question: 'What is your pricing', 
            answer: 'We currently offer a pay-as-you-go model wherein 10,000 API credits cost $10 USD. Subscription plans details can be found below. A single request to most of the supported platforms costs 10 credits. More details can be found on the docs page for each platform.' 
          },
          { 
            question: 'What Platforms do you support', 
            answer: 'We currently offer a pay-as-you-go model wherein 10,000 API credits cost $10 USD. Subscription plans details can be found below. A single request to most of the supported platforms costs 10 credits. More details can be found on the docs page for each platform.' 
          },
        ],
        activeFaqIndex: null,
      }
    }

};
</script>

<style lang="scss" scoped>
.intro {
  padding-top: 80px;
  padding-bottom: 80px;
}
.highlighted-text {
    border-radius: 1em 0 1em 0;
    background-image: linear-g
    radient(-100deg,rgba(247,198,2,.05),rgba(247,198,2,.5) 95%,rgba(247,198,2,0));
}

.border-green-500 {
  border-style: solid;
}

.flex, .child-flex > * {
  flex: inherit;
}
.fa {
  margin-right: 0.5rem;
}
</style>

